import * as React from "react";
import * as Highcharts from 'highcharts';
//import drilldown from 'highcharts-drilldown';
import * as AuthStore from "../store/Auth";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { ApplicationState } from '../store';
import { fetchData } from '../utils';
import { busyGif } from '../img';
import { Card, Row, Col, Button, Select } from 'antd';
import { InboxOutlined, CloseCircleOutlined, SearchOutlined } from '@ant-design/icons';
const { Option } = Select;


type AuthProps =
    AuthStore.AuthState // ... state we've requested from the Redux store
    & typeof AuthStore.actionCreators // ... plus action creators we've requested

class Home extends React.Component<AuthProps>
{
    public state =
    {
        labresult: false,
        linelist: false,
        loading: false,
            showDetails: false,
            selected: { value: 0, label: "Select Facility", key: 0 },
        sites: [],
        site: { id: '', name: '', stateCode: '', lga: '', siteId: '', state: '' },
        state: { id: 0, name: '', code: '', sites: [] },
        filter: { state: '', site: '', startDate: null, endDate: null, },
            dashboard: { siteName: '', datimCode: '', tested: 0, suppressed: 0, unsuppressed: 0, totalPbs: 0, pbsFemales: 0, pbsMales: 0, totalTxNew: 0, txNewFemales: 0, txNewMales: 0, females: 0, males: 0, total: 0, stateStats: [] },
        user: { id: '', firstName: '', lastName: '', email: '', isAuthenticated: false, code: -1, userName: '', role: '', message: '' },
        siteName: '',
            stateName: '',
            facility:
            {
                id: 0,
                name: '',
                stateCode: '',
                active: 0,
                inactive: 0,
                totalClients: 0,
                totalOnArt: 0,
                newClients: 0
            }
        };

    public stateNames = [{ id: 2, code: 'KD', name: 'KADUNA', sites: [] }, { id: 3, code: 'KG', name: 'KOGI', sites: [] }, { id: 1, code: 'GB', name: 'GOMBE', sites: [] }, { id: 4, code: 'LG', name: 'LAGOS', sites: [] }];
    
    ////@ts-ignore
    async UNSAFE_componentWillMount()
    {
        let sts = localStorage.getItem("stateNames");       
        if (!sts)
        {
            localStorage.setItem('stateNames', JSON.stringify(this.stateNames));
        }

        let user = this.props.appUser;

        if (this.props.appUser.isAuthenticated)
        {
            if (user.stateCode != null)
            var states = this.stateNames.filter(s =>
            {
                return s.code.toLocaleLowerCase() === user.stateCode.toLocaleLowerCase();
            });

            if (states.length > 0)
            {
                this.setState({state: states[0]})
            }

            this.getStats();
        }    
    }    

    closeView()
    {
        console.log('onClear called!');
        this.setState({
            selected: { value: 0, label: "Select Facility", key: 0 },
            showDetails: false,
            site: { id: '', name: '', stateCode: '', lga: '', siteId: '', state: '' },
            facility:
            {
                id: 0,
                name: '',
                stateCode: '',
                active: 0,
                inactive: 0,
                totalClients: 0,
                totalOnArt: 0,
                newClients: 0
            } });
    }

    async getStats()
    {
        let el = this;       
        el.setState({ loading: true });
        let stateCode = el.state.state.code.length > 0 ? el.state.state.code : "";
        var url = `/api/Stats/getDashboard?stateId=` + el.props.appUser.stateId;
        let res = await fetchData(url);
        let dashboard = res;
        el.setState({ dashboard });

        el.setState({ loading: false });

        if (res.stateStats && res.stateStats.length > 0)
        {
            var sites = [];   
            let user = el.props.appUser;

            if (user.stateCode && user.stateCode.length > 0)
            {
                var statex = el.stateNames.filter(s =>
                {
                    return s.code.toLocaleLowerCase() === user.stateCode.toLocaleLowerCase();
                });

                if (statex.length > 0)
                {
                    el.setState({ state: statex[0] });
                }
            }

            let actives: any[] = [];
            let maleCounts: number[] = [];
            let femaleCounts: number[] = [];
            let malePbs: number[] = [];
            let femalePbs: number[] = [];
            let percentagePbsCoverage: number[] = [];
            let categories: string[] = [];

                //tested: 0, suppressed: 0, unsuppressed: 0, totalPbs: 0, pbsFemales: 0, pbsMales: 0, totalTxNew: 0, txNewFemales: 0, txNewMales: 0, females: 0, males: 0, total: 0, sites: [], stateStats
            // Create the chart               
            dashboard.stateStats.map(function (p: any)
            {
                sites = sites.concat(p.sites);   
                actives.push(p.totalActive);
                maleCounts.push(p.activeMales);
                malePbs.push(p.pbsMales);
                femalePbs.push(p.pbsFemales);
                femaleCounts.push(p.activeFeMales);

                if (p.totalActive > 0)
                {
                    percentagePbsCoverage.push(((p.pbsMales + p.pbsFemales) * 100) / p.totalActive);
                }
                else
                {
                    percentagePbsCoverage.push(0);
                }

                let states = el.stateNames.filter(function (s: any) { return s.code === p.stateCode });
                if (states && states.length > 0)
                {
                    p.stateId = states[0].id;
                    p.stateName = states[0].name;
                    p.sites.map(function (ss: any)
                    {
                        ss.stateId = p.stateId;
                        ss.stateName = p.stateName;
                    });

                    categories.push(p.stateName);
                }                
            });
                       
            localStorage.removeItem('states');
            localStorage.setItem('states', JSON.stringify(dashboard.stateStats));
            el.setState({ sites: sites });

            //let colors = ['#95CEFF', '#50B432', '#24CBE5', '#ff7043', '#DDDF00', '#24CBE5',
            //    '#64E572', '#FF9655', '#FFF263', '#6AF9C4'];

            //let colors = ['#3aacae', '#50B432', '#24CBE5', '#3aacae', '#95cc3e'];

            //Render By State
            Highcharts.chart(
            {
                chart:
                {
                    renderTo: 'patient-year',
                    type: 'column'
                },
                title: {
                    text: 'TX_CURR Distribution By State'
                },
                subtitle: {
                    text: 'Disaggregated by Sex'
                },
                xAxis: { categories: categories, type: 'category' },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Active Patients'
                    },
                    labels: {
                        format: '{value}',
                        style: {
                            color: Highcharts.getOptions().colors[1]
                        }
                    }
                },
                tooltip: {
                    headerFormat: '<table style="width: 110px"><tr style="font-size:12px; font-weight: bold; border-bottom: thin solid #ddd"><td>{point.key}</td></tr>',
                    pointFormat: '<tr style="font-size:11px;"><td style="color:{series.color};padding:0">{series.name}: </td>' +
                        '<td style="padding:0"><b>{point.y}</b><br/></td></tr>',
                    footerFormat: '</table>',
                    shared: true,
                    useHTML: true
                },
                plotOptions: {
                    column: {
                        shadow: false,
                        borderWidth: 0,
                    }
                },
                //colors: colors,
                series: [
                    //{ name: 'Active', data: actives, type: 'column' },                        
                    { name: 'Female', data: femaleCounts, type: 'column', pointPadding: 0 },
                    { name: 'Male', data: maleCounts, type: 'column', pointPadding: 0 },
                ]
            });

            var pbsToolTip =
            {
                headerFormat: '<table style="width: 110px"><tr style="font-size:12px; font-weight: bold; border-bottom: thin solid #ddd"><td colspan="2">{point.key}</td></tr>',
                pointFormat: '<tr style="font-size:11px;background-color: #fff"><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '<td style="padding:0"><b>{point.y:,.1f}%</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true
            };

            //Render PBS Coverage
            Highcharts.chart(
            {
                chart: {
                    renderTo: 'pbs',
                    type: 'column'
                },
                title: {
                    text: 'PBS Coverage By State'
                },
                subtitle: {
                    text: 'Disaggregated by Sex'
                },
                xAxis: {
                    categories: categories,
                    crosshair: true
                },
                yAxis: [{ // Primary yAxis
                    gridLineWidth: 0,
                    minorGridLineWidth: 0,
                    labels: {
                        format: '{value}',
                        style: {
                            color: '#000'
                        }
                    },
                    title: {
                        text: 'Active Patients',
                        style: {
                            color: '#000'
                        }
                    }
                }, { // Secondary yAxis
                    title: {
                        text: '% Covered',
                        rotation: 270,
                        style: {
                            color: '#000'
                        }
                    },
                    gridLineWidth: 0,
                    minorGridLineWidth: 0,
                    min: 0,
                    max: 100,
                    //labels: {
                    //    format: '{value}%',
                    //    style: {
                    //        color: Highcharts.getOptions().colors[1]
                    //    }
                    //},
                    opposite: true,
                    showFirstLabel: false,
                    showLastLabel: true
                }],
                legend: {
                    align: 'left',
                    x: 50,
                    verticalAlign: 'bottom',
                    y: 22,
                    floating: false,
                    backgroundColor: 'white',
                    borderColor: '#fff',
                    borderWidth: 0,
                    shadow: false
                },
                tooltip: {
                    headerFormat: '<table style="width: 110px"><tr style="font-size:12px; font-weight: bold; border-bottom: thin solid #ddd"><td colspan="2">{point.key}</td></tr>',
                    pointFormat: '<tr style="font-size:11px;background-color: #fff"><td style="color:{series.color};padding:0">{series.name}: </td>' +
                        '<td style="padding:0"><b>{point.y:,.0f}</b></td></tr>',
                    footerFormat: '</table>',
                    shared: true,
                    useHTML: true
                },
                plotOptions: {
                    column: {
                        borderWidth: 0,
                        shadow: false,
                        stacking: 'normal'
                    }
                },
                colors: ['rgb(124,181,236)', '#B4C7E7', 'rgb(67,67,72)', '#7030A0', '#4472C4'], //#7030A0
                series: [                    
                    { name: 'Active', data: actives, type: 'column', pointPadding: 0},
                    { name: 'Female', data: femalePbs, type: 'column', pointPadding: 0, stack: 'Male' },
                    { name: 'Male', data: malePbs, type: 'column', pointPadding: 0, stack: 'Male' },
                    { name: 'PBS Coverage', data: percentagePbsCoverage, yAxis: 1, type: 'scatter', marker: { radius: 4 }, tooltip: pbsToolTip, dataLabels: { enabled: true, format: '{point.y:,.1f}%' } }
                ]
            });
                
        }        
       
    }

    redirect()
    {
        this.setState({ redirect: true });
    }

    render()
    {
        const { dashboard, loading, state, sites, showDetails, facility, site } = this.state;
       
        let sts = this.stateNames;
        let user = this.props.appUser;

        let userState = "";
        if (user.stateCode && user.stateCode.length > 0)
        {
               userState = this.state.state.name;            
        }
      
        return <div className="dashboard" style={{ backgroundColor: 'rgb(240, 242, 245, 0.15)' }}>
                <Helmet>
                    <title>CDR | Dashboard</title>
            </Helmet>
            {loading && <img className="waiter" src={busyGif} alt="" style={{ width: '54px', height: '54px' }} />}           

            <Row style={{ display: showDetails ? 'none' : 'block' }}>
                <Row className="row-30px-pad-10px-top" style={{ paddingTop: '10px' }}>
                    <Col xs={24} sm={24} md={24} lg={16} xl={16} className="stat-card">
                        <h4 style={{ fontWeight: 'bold', fontSize: '17px' }}> {userState && userState.length > 0 ? userState : state && state.name.length > 0 ? state.name : ''} TX Indicators [* AS AT TODAY] </h4>
                    </Col>                    
                    <Col xs={24} sm={24} md={24} lg={8} xl={8} className="stat-card">
                        {sites && <h4>Facilities: <span style={{ fontWeight: 'bold', fontSize: '22px' }} className="db-h3-t">{String(sites.length).replace(/(.)(?=(\d{3})+$)/g, '$1,')}</span></h4>}
                    </Col>
                </Row>
                <Row className="sr row-30px-pad-10px-top">
                    <Col xs={24} sm={12} md={12} lg={12} xl={6} className="stat-card" style={{marginTop: '15px'}}>
                        <Card className="ant-card-body pfs s-list">
                            <div className="custom-image">
                                <h3 className="db-h3 db-h3-i">{String(dashboard.total).replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                            </div>
                            {/*<TeamOutlined className="db-i" />*/}
                            <svg className="bi bi-people db-i" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.995-.944v-.002.002zM7.022 13h7.956a.274.274 0 00.014-.002l.008-.002c-.002-.264-.167-1.03-.76-1.72C13.688 10.629 12.718 10 11 10c-1.717 0-2.687.63-3.24 1.276-.593.69-.759 1.457-.76 1.72a1.05 1.05 0 00.022.004zm7.973.056v-.002.002zM11 7a2 2 0 100-4 2 2 0 000 4zm3-2a3 3 0 11-6 0 3 3 0 016 0zM6.936 9.28a5.88 5.88 0 00-1.23-.247A7.35 7.35 0 005 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 015 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10c-1.668.02-2.615.64-3.16 1.276C1.163 11.97 1 12.739 1 13h3c0-1.045.323-2.086.92-3zM1.5 5.5a3 3 0 116 0 3 3 0 01-6 0zm3-2a2 2 0 100 4 2 2 0 000-4z" clipRule="evenodd" />
                            </svg>
                            <div className="custom-card" title="View more">
                                <h3>TX_CURR (+28 days)&nbsp;</h3>
                            </div>
                        </Card>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12} xl={6} className="stat-card" style={{ marginTop: '15px' }}>
                        <Card className="ant-card-body pfs s-list">
                            <div className="custom-image">
                                <h3 className="db-h3 db-h3-g">{String(dashboard.totalTxNew).replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                            </div>
                            {/*<UsergroupAddOutlined className="db-i" />*/}
                            <svg className="bi bi-person-plus db-i" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" d="M11 14s1 0 1-1-1-4-6-4-6 3-6 4 1 1 1 1h10zm-9.995-.944v-.002.002zM1.022 13h9.956a.274.274 0 00.014-.002l.008-.002c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664a1.05 1.05 0 00.022.004zm9.974.056v-.002.002zM6 7a2 2 0 100-4 2 2 0 000 4zm3-2a3 3 0 11-6 0 3 3 0 016 0zm4.5 0a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 010-1H13V5.5a.5.5 0 01.5-.5z" clipRule="evenodd" />
                                <path fillRule="evenodd" d="M13 7.5a.5.5 0 01.5-.5h2a.5.5 0 010 1H14v1.5a.5.5 0 01-1 0v-2z" clipRule="evenodd" />
                            </svg>
                            <div className="custom-card">
                                <h3>TX_NEW (In current Quarter)&nbsp;</h3>
                            </div>
                        </Card>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12} xl={6} className="stat-card" style={{ marginTop: '15px' }}>
                        <Card className="ant-card-body pfs s-list">
                            <div className="custom-image">
                                <h3 className="db-h3 db-h3-n">{String(dashboard.tested).replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                            </div>
                            {/*<SolutionOutlined className="db-i" />*/}
                            <svg className="bi bi-list-ol db-i" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" d="M5 11.5a.5.5 0 01.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5zm0-4a.5.5 0 01.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5zm0-4a.5.5 0 01.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5z" clipRule="evenodd" />
                                <path d="M1.713 11.865v-.474H2c.217 0 .363-.137.363-.317 0-.185-.158-.31-.361-.31-.223 0-.367.152-.373.31h-.59c.016-.467.373-.787.986-.787.588-.002.954.291.957.703a.595.595 0 01-.492.594v.033a.615.615 0 01.569.631c.003.533-.502.8-1.051.8-.656 0-1-.37-1.008-.794h.582c.008.178.186.306.422.309.254 0 .424-.145.422-.35-.002-.195-.155-.348-.414-.348h-.3zm-.004-4.699h-.604v-.035c0-.408.295-.844.958-.844.583 0 .96.326.96.756 0 .389-.257.617-.476.848l-.537.572v.03h1.054V9H1.143v-.395l.957-.99c.138-.142.293-.304.293-.508 0-.18-.147-.32-.342-.32a.33.33 0 00-.342.338v.041zM2.564 5h-.635V2.924h-.031l-.598.42v-.567l.629-.443h.635V5z" />
                            </svg>
                            <div className="custom-card" title="View more">
                                <h3>Tested for Viral load within Last 12 months&nbsp;</h3>
                            </div>
                        </Card>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12} xl={6} className="stat-card" style={{ marginTop: '15px' }}>
                        <Card className="ant-card-body pfs s-list">
                            <div className="custom-image">
                                <h3 className="db-h3 db-h3-b">{String(dashboard.suppressed).replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                            </div>
                            {/*<CarryOutOutlined className="db-i"/>*/}
                            <svg className="bi bi-person-check db-i" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" d="M11 14s1 0 1-1-1-4-6-4-6 3-6 4 1 1 1 1h10zm-9.995-.944v-.002.002zM1.022 13h9.956a.274.274 0 00.014-.002l.008-.002c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664a1.05 1.05 0 00.022.004zm9.974.056v-.002.002zM6 7a2 2 0 100-4 2 2 0 000 4zm3-2a3 3 0 11-6 0 3 3 0 016 0zm6.854.146a.5.5 0 010 .708l-3 3a.5.5 0 01-.708 0l-1.5-1.5a.5.5 0 01.708-.708L12.5 7.793l2.646-2.647a.5.5 0 01.708 0z" clipRule="evenodd" />
                            </svg>
                            <div className="custom-card">
                                <h3>Virally Suppressed within Last 12 months</h3>
                            </div>
                        </Card>
                    </Col>
                </Row>
                <Row gutter={2} className="row-30px-pad-10px-top state-txcurr" >
                    <Col className="ant-card-bordered top-20px" xs={24} sm={24} md={12} lg={12} xl={12} id="patient-year"></Col>
                    <Col span={1}></Col>
                    <Col className="ant-card-bordered top-20px" xs={24} sm={24} md={11} lg={11} xl={11} id="pbs"></Col>
                </Row>
            </Row>
        </div>;
        
    }
}

export default connect(
    (state: ApplicationState) => state.auth, // Selects which state properties are merged into the component's props
    AuthStore.actionCreators // Selects which action creators are merged into the component's props
)(Home as any);



//function values<T>(x: T) {
//    const keys = Object.keys(x) as (keyof T)[];
//    return keys.map(s => x[s]);
//}